import template from './card.vhtml';

export default {
	template,
	props: {
		'card': {
			type: Object,
			default: [],
		},
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/card/card.js